export default __webpack_public_path__ + "static/media/genralCategory.a488d7ab.png";